import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHome\DeleteFuneralHomeController::deleteMethod
* @see app/Http/Controllers/FuneralHome/DeleteFuneralHomeController.php
* @route '/api/funeral_home-delete/{funeral_home}'
*/
export const deleteMethod = (args: { funeral_home: string | number } | [funeral_home: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/funeral_home-delete/{funeral_home}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\FuneralHome\DeleteFuneralHomeController::deleteMethod
* @see app/Http/Controllers/FuneralHome/DeleteFuneralHomeController.php
* @route '/api/funeral_home-delete/{funeral_home}'
*/
deleteMethod.url = (args: { funeral_home: string | number } | [funeral_home: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { funeral_home: args }
    }

    if (Array.isArray(args)) {
        args = {
            funeral_home: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        funeral_home: args.funeral_home,
    }

    return deleteMethod.definition.url
            .replace('{funeral_home}', parsedArgs.funeral_home.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHome\DeleteFuneralHomeController::deleteMethod
* @see app/Http/Controllers/FuneralHome/DeleteFuneralHomeController.php
* @route '/api/funeral_home-delete/{funeral_home}'
*/
deleteMethod.delete = (args: { funeral_home: string | number } | [funeral_home: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\FuneralHome\DeleteFuneralHomeController::undo
* @see app/Http/Controllers/FuneralHome/DeleteFuneralHomeController.php
* @route '/api/funeral_home/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/funeral_home/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHome\DeleteFuneralHomeController::undo
* @see app/Http/Controllers/FuneralHome/DeleteFuneralHomeController.php
* @route '/api/funeral_home/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHome\DeleteFuneralHomeController::undo
* @see app/Http/Controllers/FuneralHome/DeleteFuneralHomeController.php
* @route '/api/funeral_home/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHome\DeleteFuneralHomeController::undo
* @see app/Http/Controllers/FuneralHome/DeleteFuneralHomeController.php
* @route '/api/funeral_home/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteFuneralHomeController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteFuneralHomeController